import { useEffect, useState } from 'react';
import { useClient } from 'hooks/useClient';
import { useQuery } from 'react-query';
import fp from 'lodash/fp';
import { useSession } from 'store/session';
import { getSessionTokenV3 } from 'helpers/sessionContext';


export const useFetchAll = (
  initialValues: { pageSize: number } = { pageSize: 15 },
) => {
  const client = useClient({
    url: process.env.REACT_APP_API_V3,
    token: getSessionTokenV3() as string,
  });

  const [like, setLike] = useState<null | string>(null);

  const [pageSize, setPageSize] = useState<number>(initialValues?.pageSize);

  const [page, setPage] = useState<number>(1);

  const { team } = useSession();

  const teamUUID = team?.uuid as string;

  const query = useQuery(['fetch-contacts', teamUUID], async () => {
    const response = await client.getContactsAll(teamUUID, {
      name_like: !fp.isEmpty(like) ? like : null,
      limit: pageSize,
      page,
      sort: 'email',
      order: 'ASC',
    });

    return {
      count: fp.get(['headers', 'x-total-count'])(response),
      data: fp.get('data')(response),
    };
  });

  useEffect(() => {
    if (query?.isFetchedAfterMount) query?.refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [like, page, pageSize]);

  return { ...query, like, page, setLike, setPage, pageSize, setPageSize };
};
